<template>
  <div class="checkbox-input">
    <div class="form-group row">
      <label v-if="options.label" :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <div class="checkbox fas">
          <label class="switch fas fa-2x" :class="{ 'fa-toggle-on text-success': value, 'fa-toggle-on fa-flip-horizontal text-muted': !value }">
            <input type="checkbox"
              :id="options.name"
              :checked="value"
              :name="options.name"
              :disabled="options.disabled"
              @change="validate($event.target.checked)"/>
              <span class="slider round"></span>
          </label>
        </div>
        <div v-show="value && options.checkboxLabel" class="form-section-success" v-html="options.checkboxLabel"></div>
        <div v-show="!value && options.checkboxOffLabel" class="form-section-info" v-html="options.checkboxOffLabel"></div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/vuex/api'
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'CheckboxInput',
  props: {
    value: {
      type: Boolean
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          checkboxLabel: '',
          disabled: false,
          required: false
        }
      }
    }
  },
  data () {
    return {
      isDirty: false,
      isValid: false,
      choices: false
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      return this.options.invalidMessage ? this.options.invalidMessage : 'Invalid value!'
    }
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      if (this.options.required) {
        this.isDirty = true
        this.isValid = val
      } else {
        this.isValid = true
      }
    },
    runWatcher (val, name) {
      switch (name) {
        case 'cars':
          if (this.options.name === 'allCars') {
            if (val.length > 0) {
              this.$el.style.display = 'none'
            } else {
              this.$el.style.display = 'block'
            }
          }
          break
        case 'postcodes':
          if (this.options.name === 'allMembers') {
            if (val.length > 0) {
              this.$el.style.display = 'none'
            } else {
              this.$el.style.display = 'block'
            }
          }
          break
        case 'council':
        case 'contract':
          if (this.options.name === 'allCars') {
            if (val) {
              this.$el.style.display = 'none'
            } else {
              this.$el.style.display = 'block'
            }
          }
          break
        case 'AccountTypeUuid':
          this.getAccountTypeName(val)
          break
      }
    },
    async getAccountTypeName (val) {
      if (val) {
        let instance = new Api()
        let results = await instance.getAccountType({
          accountTypeUuid: val
        })
        if (results.name === 'Casual') {
          this.options.disabled = false
        } else {
          // First uncheck the checkbox and then disable it.
          this.options.value = false
          this.options.disabled = true
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/CheckboxInput.vue